/** Interval for visible-tab `/version.json` poll (deploy sync for in-memory JS bundle). */
export const VISIBLE_TAB_DEPLOY_SYNC_INTERVAL_MS = 90 * 1000

/** Minimum gap between visibility-triggered `reg.update()` calls (SW script discovery only). */
export const SW_UPDATE_CHECK_MIN_INTERVAL_MS = VISIBLE_TAB_DEPLOY_SYNC_INTERVAL_MS

export function shouldAttemptSwUpdate(now: number, lastAttemptMs: number): boolean {
  if (lastAttemptMs <= 0 || lastAttemptMs > now) {
    return true
  }
  return now - lastAttemptMs >= SW_UPDATE_CHECK_MIN_INTERVAL_MS
}
